import React from "react";
import { useMediaQuery } from "@mui/material";

interface FormComponentProps {
    children: React.ReactNode;
    className?: string; // Allow additional custom styling
    title?: string;
    noShadow?: boolean; // The new prop to control shadow
    isFullScreen?: boolean; // The new prop to control full screen padding
    isModal?: boolean; // New prop to handle modal padding
}

const FormComponent: React.FC<FormComponentProps> = ({
                                                         children,
                                                         className,
                                                         title,
                                                         noShadow = true,
                                                         isFullScreen = false,
                                                         isModal = false,
                                                     }) => {
    const isMobile = useMediaQuery("(max-width:1100px)"); // Adjusted media query for better transition
    const commonClassName = "bg-white dark:bg-gray-800 w-full";
    const isML = isMobile || isModal ? "" : "sm:ml-72";

    return (
        <div className={commonClassName}>
            <div className={`ml-0 px-6 py-8 max-w-5xl mx-auto w-full ${isML} ${className || ""}`}>
                {title && (
                    <div className="w-full">
                        <h1 className={`text-2xl font-semibold ${isModal ? "py-2" : (isMobile ? "py-4 px-4" : "px-10 py-6")}`}>
                            {title}
                        </h1>
                        <div className={`pb-3 ${isModal ? "py-2" : (isMobile ? "py-4 px-4" : "px-10")}`}>
                            <hr className="border-gray-300 dark:border-gray-600"/>
                        </div>
                    </div>
                )}
                <div className={`${isModal ? "py-2" : (isMobile ? "py-4 px-4" : "px-10 py-6")} w-full`}>{children}</div>
            </div>
        </div>
    );
};

export default FormComponent;
